import React, { Component } from 'react';
import ReactExport from 'react-data-export';
import { Button } from '@progress/kendo-react-buttons';
import moment from 'moment';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;

class ProjectAndCrReport extends Component {
    constructor(props) {
        super(props);

        this.state = {
            projectData: null,
            crData: null,
            nullData: [{ columns: [], data: [] }],
        };
    }

    componentDidMount() {
        if (this.props.updateData === true) {
            this.populateProjectandCrData();
        }
    }

    componentDidUpdate = async() => {
        if (this.props.updateData === true) {
            this.props.dataUpdated();
            await this.populateProjectandCrData();
            document.getElementById("projectAndCrReport").click();
        }
    }

    populateProjectandCrData = async() => {
        let projectData = [];
        let crData = [];
        const borderStyle = {
            border: {
                top: { style: "thin", color: "000000" },
                right: { style: "thin", color: "000000" },
                bottom: { style: "thin", color: "000000" },
                left: { style: "thin", color: "000000" }
            }
        };

        if (this.props.projectData && this.props.projectData.length > 0) { 
            for (const record of this.props.projectData) {
                projectData.push([
                    {
                        value: record.ProjectName ? record.ProjectName : '',
                        style: borderStyle
                    },
                    {
                        value: record.UniqueId ? record.UniqueId : '',
                        style: borderStyle
                    },
                    {
                        value: record.OPID ? record.OPID : '',
                        style: borderStyle
                    },
                    {
                        value: record.Status ? record.Status : '',
                        style: borderStyle
                    },
                    {
                        value: record.EngagementType ? record.EngagementType : '',
                        style: borderStyle
                    },
                    {
                        value: record.Customer ? record.Customer : '',
                        style: borderStyle
                    },
                    {
                        value: record.Department ? record.Department : '',
                        style: borderStyle
                    },
                    {
                        value: record.Practice ? record.Practice : '',
                        style: borderStyle
                    },
                    {
                        value: record.BillingRegion ? record.BillingRegion : '',
                        style: borderStyle
                    },
                    {
                        value: record.ProjectManager ? record.ProjectManager : '',
                        style: borderStyle
                    },
                    {
                        value: record.PrimaryManager ? record.PrimaryManager : '',
                        style: borderStyle
                    },
                    {
                        value: record.StartDate ? record.StartDate : '',
                        style: borderStyle
                    },
                    {
                        value: record.EndDate ? record.EndDate : '',
                        style: borderStyle
                    },
                    {
                        value: record.LastTimeEnteredDate ? record.LastTimeEnteredDate : '',
                        style: borderStyle
                    },
                    {
                        value: record.LastThreeMonthStatus ? record.LastThreeMonthStatus : '',
                        style: borderStyle
                    },
                    {
                        value: record.ProjectCmsRevenueUSD ? record.ProjectCmsRevenueUSD : '',
                        style: borderStyle
                    },
                    {
                        value: record.PaymentMethod ? record.PaymentMethod : '',
                        style: borderStyle
                    },
                    {
                        value: record.ActiveOrWARDate ? record.ActiveOrWARDate : '',
                        style: borderStyle
                    },
                    {
                        value: record.ConvertedToActiveAt ? record.ConvertedToActiveAt : '',
                        style: borderStyle
                    },
                    {
                        value: record.CompletedDate ? record.CompletedDate : '',
                        style: borderStyle
                    },
                    {
                        value: record.ClosedDate ? record.ClosedDate : '',
                        style: borderStyle
                    },
                    {
                        value: record.IsGDC ? record.IsGDC : '',
                        style: borderStyle
                    },
                    {
                        value: record.Offering ? record.Offering : '',
                        style: borderStyle
                    },
                ])
            }

            let headerColumns = [
                { value: 'Project Name',  style: {font: { bold: true }, border: borderStyle.border}},
                { value: 'Project ID',  style: {font: { bold: true }, border: borderStyle.border}},
                { value: 'OPID',  style: {font: { bold: true }, border: borderStyle.border}},
                { value: 'Status',  style: {font: { bold: true }, border: borderStyle.border}},
                { value: 'Engagement Type',  style: {font: { bold: true }, border: borderStyle.border}},
                { value: 'Customer Name',  style: {font: { bold: true }, border: borderStyle.border}},
                { value: 'Department',  style: {font: { bold: true }, border: borderStyle.border}},
                { value: 'Practice',  style: {font: { bold: true }, border: borderStyle.border}},
                { value: 'Billing Region',  style: {font: { bold: true }, border: borderStyle.border}},
                { value: 'Manager',  style: {font: { bold: true }, border: borderStyle.border}},
                { value: 'Primary Manager',  style: {font: { bold: true }, border: borderStyle.border}},
                { value: 'Project Start Date',  style: {font: { bold: true }, border: borderStyle.border}},
                { value: 'Project End Date',  style: {font: { bold: true }, border: borderStyle.border}},
                { value: 'Last Time Entered Date',  style: {font: { bold: true }, border: borderStyle.border}},
                { value: 'Time Entered for Last 03 Months',  style: {font: { bold: true }, border: borderStyle.border}},
                { value: 'Project Revenue After Discount',  style: {font: { bold: true }, border: borderStyle.border}},
                { value: 'Payment Method',  style: {font: { bold: true }, border: borderStyle.border}},
                { value: 'Active Or WAR Date',  style: {font: { bold: true }, border: borderStyle.border}},
                { value: 'Activated Date',  style: {font: { bold: true }, border: borderStyle.border}},
                { value: 'Completed Date',  style: {font: { bold: true }, border: borderStyle.border}},
                { value: 'Closed Date',  style: {font: { bold: true }, border: borderStyle.border}},
                { value: 'GDC',  style: {font: { bold: true }, border: borderStyle.border}},
                { value: 'Offering',  style: {font: { bold: true }, border: borderStyle.border}},
            ];

            let emptyRow = [];
            for (const row of headerColumns) {
                let record = { title: '', width: { wpx: 150 } }
                emptyRow.push(record);    
            }

            const projectListGrid = [
                {
                    columns: [
                        {title: `Project List - ${moment(new Date()).format('DD-MMM-YYYY')}`, width: {wpx: 150}},
                        {title: '', width: {wpx: 150}},
                    ],
                    data: []
                },
                {
                    columns: emptyRow,
                    data: [headerColumns, ...projectData]
                }
            ];
    
            await this.setState({
                projectListGrid: projectListGrid
            });
        }

        if (this.props.crData && this.props.crData.length > 0) { 
            for (const record of this.props.crData) {
                crData.push([
                    {
                        value: record.CRName ? record.CRName : '',
                        style: borderStyle
                    },
                    {
                        value: record.UniqueId ? record.UniqueId : '',
                        style: borderStyle
                    },
                    {
                        value: record.OPID ? record.OPID : '',
                        style: borderStyle
                    },
                    {
                        value: record.ProjectUniqueId ? record.ProjectUniqueId : '',
                        style: borderStyle
                    },
                    {
                        value: record.ProjectOPID ? record.ProjectOPID : '',
                        style: borderStyle
                    },
                    {
                        value: record.Status ? record.Status : '',
                        style: borderStyle
                    },
                    {
                        value: record.EngagementType ? record.EngagementType : '',
                        style: borderStyle
                    },
                    {
                        value: record.Customer ? record.Customer : '',
                        style: borderStyle
                    },
                    {
                        value: record.Department ? record.Department : '',
                        style: borderStyle
                    },
                    {
                        value: record.Practice ? record.Practice : '',
                        style: borderStyle
                    },
                    {
                        value: record.BillingRegion ? record.BillingRegion : '',
                        style: borderStyle
                    },
                    {
                        value: record.ProjectManager ? record.ProjectManager : '',
                        style: borderStyle
                    },
                    {
                        value: record.PrimaryManager ? record.PrimaryManager : '',
                        style: borderStyle
                    },
                    {
                        value: record.StartDate ? record.StartDate : '',
                        style: borderStyle
                    },
                    {
                        value: record.EndDate ? record.EndDate : '',
                        style: borderStyle
                    },
                    {
                        value: record.LastTimeEnteredDate ? record.LastTimeEnteredDate : '',
                        style: borderStyle
                    },
                    {
                        value: record.LastThreeMonthStatus ? record.LastThreeMonthStatus : '',
                        style: borderStyle
                    },
                    {
                        value: record.ProjectCmsRevenueUSD ? record.ProjectCmsRevenueUSD : '',
                        style: borderStyle
                    },
                    {
                        value: record.PaymentMethod ? record.PaymentMethod : '',
                        style: borderStyle
                    },
                    {
                        value: record.ActiveOrWARDate ? record.ActiveOrWARDate : '',
                        style: borderStyle
                    },
                    {
                        value: record.ConvertedToActiveAt ? record.ConvertedToActiveAt : '',
                        style: borderStyle
                    },
                    {
                        value: record.CompletedDate ? record.CompletedDate : '',
                        style: borderStyle
                    },
                    {
                        value: record.ClosedDate ? record.ClosedDate : '',
                        style: borderStyle
                    },
                    {
                        value: record.IsGDC ? record.IsGDC : '',
                        style: borderStyle
                    },
                    {
                        value: record.Offering ? record.Offering : '',
                        style: borderStyle
                    },
                ])
            }

            let headerColumns = [
                { value: 'CR Name',  style: {font: { bold: true }, border: borderStyle.border}},
                { value: 'CR ID',  style: {font: { bold: true }, border: borderStyle.border}},
                { value: 'CR OPID',  style: {font: { bold: true }, border: borderStyle.border}},
                { value: 'Project ID',  style: {font: { bold: true }, border: borderStyle.border}},
                { value: 'Project OPID',  style: {font: { bold: true }, border: borderStyle.border}},
                { value: 'Status',  style: {font: { bold: true }, border: borderStyle.border}},
                { value: 'Engagement Type',  style: {font: { bold: true }, border: borderStyle.border}},
                { value: 'Customer Name',  style: {font: { bold: true }, border: borderStyle.border}},
                { value: 'Department',  style: {font: { bold: true }, border: borderStyle.border}},
                { value: 'Practice',  style: {font: { bold: true }, border: borderStyle.border}},
                { value: 'Billing Region',  style: {font: { bold: true }, border: borderStyle.border}},
                { value: 'Manager',  style: {font: { bold: true }, border: borderStyle.border}},
                { value: 'Primary Manager',  style: {font: { bold: true }, border: borderStyle.border}},
                { value: 'Project Start Date',  style: {font: { bold: true }, border: borderStyle.border}},
                { value: 'Project End Date',  style: {font: { bold: true }, border: borderStyle.border}},
                { value: 'Last Time Entered Date',  style: {font: { bold: true }, border: borderStyle.border}},
                { value: 'Time Entered for Last 03 Months',  style: {font: { bold: true }, border: borderStyle.border}},
                { value: 'Project Revenue After Discount',  style: {font: { bold: true }, border: borderStyle.border}},
                { value: 'Payment Method',  style: {font: { bold: true }, border: borderStyle.border}},
                { value: 'Active Or WAR Date',  style: {font: { bold: true }, border: borderStyle.border}},
                { value: 'Activated Date',  style: {font: { bold: true }, border: borderStyle.border}},
                { value: 'Completed Date',  style: {font: { bold: true }, border: borderStyle.border}},
                { value: 'Closed Date',  style: {font: { bold: true }, border: borderStyle.border}},
                { value: 'GDC',  style: {font: { bold: true }, border: borderStyle.border}},
                { value: 'Offering',  style: {font: { bold: true }, border: borderStyle.border}},
            ];

            let emptyRow = [];
            for (const row of headerColumns) {
                let record = { title: '', width: { wpx: 150 } }
                emptyRow.push(record);    
            }

            const crListGrid = [
                {
                    columns: [
                        {title: `CR List - ${moment(new Date()).format('DD-MMM-YYYY')}`, width: {wpx: 150}},
                        {title: '', width: {wpx: 150}},
                    ],
                    data: []
                },
                {
                    columns: emptyRow,
                    data: [headerColumns, ...crData]
                }
            ];
    
            await this.setState({
                crListGrid: crListGrid
            });
        }
    }

    render() {
        return (
            <ExcelFile
                filename={'Project and CR List - ' + moment(new Date()).format('DD-MMM-YYYY')}
                element={ 
                    <Button id={"projectAndCrReport"} className="d-none">
                        {''}
                    </Button>
                }
            >
                <ExcelSheet
                    dataSet={this.state.projectListGrid ? this.state.projectListGrid : this.state.nullData}
                    name="Project List"
                />
                <ExcelSheet
                    dataSet={this.state.crListGrid ? this.state.crListGrid : this.state.nullData}
                    name="CR List"
                />
            </ExcelFile>
        );
    }
}

export default ProjectAndCrReport;
